// extracted by mini-css-extract-plugin
export default {"container":"style_container__1Zyok","image":"style_image__2SpJR","text":"style_text__dzo4X"};